var capitalizeString = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

var formatter = new Intl.NumberFormat();
var formatBytes = function (bytes) {
    if (typeof bytes !== 'number') {
        return bytes;
    }
    return formatter.format(bytes);
};

var isObject = function (obj) {
    if (!obj) {
        return false;
    }
    return Object.prototype.toString.call(obj) === '[object Object]';
};

var openModal = function (id, name, type) {
    document.dispatchEvent(new CustomEvent('@maui:modal-open', {
        detail: {
            id: id,
            name: name,
            type: type,
            status: 'open'
        }
    }));
};

export { capitalizeString, formatBytes, isObject, openModal };
